module.exports = __webpack_public_path__ + "img/GaLoginImg.5e41179a.svg";